import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { volumeCards } from '../data/volumes';
import type { VolumeAccent } from '../types/landing';
const accentBar: Record<VolumeAccent, string> = {
  emerald: 'bg-brand-emerald',
  cyan: 'bg-brand-cyan',
  gold: 'bg-brand-gold'
};
const accentText: Record<VolumeAccent, string> = {
  emerald: 'text-[#1a8c42]',
  cyan: 'text-[#0e8f9c]',
  gold: 'text-[#a2700a]'
};
export function WhatsInside() {
  return <section className="bg-[#f7f3ea]" data-id="element-190" data-mp="b4llkzuunfh0">
      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-191" data-mp="fy6kcu49odh9">
        <div className="max-w-3xl" data-id="element-192" data-mp="26jb7tp87ah2">
          <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-navy-900 sm:text-4xl" data-id="element-193" data-mp="27kyqxnfhpfo">
            One Complete Edition. A Clear Route From Grade 1 to Grade 5.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-navy-700/80 sm:text-lg" data-id="element-194" data-mp="3odhv9lq1pydq">
            Three focused math volumes build skills step by step — from early
            number sense to multi-step problem solving.
          </p>
        </div>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-id="element-195" data-mp="37v32xyxhowkh">
          {volumeCards.map(card => <li key={card.id} className="group flex flex-col border border-navy-900/10 bg-white shadow-[0_1px_2px_rgba(11,22,32,0.06)] transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-1 hover:shadow-[0_18px_36px_-18px_rgba(11,22,32,0.35)]" data-id="element-196" data-mp="3luvo7eq8ykl2">
              <span className={`h-1 w-full ${accentBar[card.accent]}`} aria-hidden="true" data-id="element-197" data-mp="2p5efsrzvqkfo" />
              <div className="bg-navy-900 p-4" data-id="element-198" data-mp="32xukrycccsj8">
                <img src={card.cover} alt={card.coverAlt} className="mx-auto block w-full max-w-[220px] shadow-[0_14px_28px_-14px_rgba(0,0,0,0.9)] ring-1 ring-white/10" data-id="element-199" data-mp="2y4rld9kvuov4" />
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-200" data-mp="26c0xpnh9m8hh">
                <h3 className="font-pixel text-[11px] uppercase leading-relaxed tracking-[0.06em] text-navy-900" data-id="element-201" data-mp="9cg0vah38b78">
                  {card.title}
                </h3>
                <p className={`mt-1.5 text-sm font-bold uppercase tracking-wide ${accentText[card.accent]}`} data-id="element-202" data-mp="j2hef8bteb7w">
                  {card.subtitle}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-navy-700/80" data-id="element-203" data-mp="3mk99wwp5tdau">
                  {card.copy}
                </p>
                {card.label ? <p className="mt-auto flex items-center gap-2 pt-5 text-xs font-semibold uppercase tracking-wide text-navy-900" data-id="element-204" data-mp="3rkx2hmt1e276">
                    <span className="flex h-5 w-5 items-center justify-center bg-brand-emerald/15 text-[#1a8c42]" aria-hidden="true" data-id="element-205" data-mp="5c5j70jxnwcj">
                      <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-206" data-mp="1gq9np0o5d2vu" />
                    </span>
                    {card.label}
                  </p> : <span className="mt-auto pt-5" aria-hidden="true" data-id="element-207" data-mp="31amxnfimcq3b" />}
              </div>
            </li>)}
        </ul>

        <div className="mt-12 text-center" data-id="element-208" data-mp="2rhz0gjnq8k42">
          <a href="#offer" className="cta-pulse cta-pulse-2 group inline-flex w-full items-center justify-center gap-2 border-b-4 border-[#071018] bg-navy-900 px-6 py-4 font-pixel text-[11px] uppercase tracking-[0.12em] text-white transition-[transform,background-color] duration-150 ease-out hover:bg-navy-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-emerald active:translate-y-[2px] sm:w-auto sm:text-sm" data-id="element-209" data-mp="2rgnuqeaq12ab">
            Explore What&rsquo;s Included
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-210" data-mp="6rqfroane0dp" />
          </a>
        </div>
      </div>
    </section>;
}